module.exports = "/_next/static/images/retailnews-9b21a4e1a91d40e561faeda6a0d3305a.png";